//日期格式化
import { formatTimeToStr } from '@/utils/date'

export function beforeTime (n) {
  let date = new Date()
  date.setMonth(date.getMonth() - n)
  date.toLocaleDateString()
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  return {name:m,value:y + '/' + m + '/1'}
}

// 当前月
export function afterTime () {
  let date = new Date()
  let seperator1 = '/'
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  let endDate = year + seperator1 + month
  return endDate + '/1'
}

export function addMonth(afterTime){
  let date = new Date()
  let year = date.getFullYear()
  let seperator = '/'
  // return afterTime
  let month = Number(afterTime.match('(?<=/).*?(?=/)')[0])
  if (month + 1  === 13) {
    year = Number(year) + 1
    month = 1
  }
  return year + seperator + month + '/1'
}

export function getImgUrl (Id,Type=1) {
  return `http://lfdc.net.cn:8845/${Id}`
  switch (Type){
    case 1:
      return `http://lfdc.net.cn/frontend/web/upload/sl-${Id}.jpg`
    case 2:
      return [`http://lfdc.net.cn/frontend/web/upload/${Id}.jpg`]
    case 3:
      return `http://lfdc.net.cn/frontend/web/upload/${Id}-.jpg`
    case 4:
      return [`http://lfdc.net.cn/frontend/web/upload/${Id}-.jpg`]
  }
}

export function problemState(state){
  switch (state) {
    case 0:
      return this.$t('question.untreated')
    case 1:
      return this.$t('question.pendingReview')
    case 2:
      return this.$t('question.processed')
    case 3:
      return this.$t('fail')
  }
}

export function AssessmentState(state){
  switch (state) {
    case 1:
      return this.$t('question.pendingReview')
    case 2:
      return this.$t('pass')
    case 3:
      return this.$t('fail')
  }
}

export function hostelOperationType(type){
  switch (type) {
    case 1:
      return "入住"
    case 2:
      return "退租"
    case 3:
      return this.$t('fail')
  }
}

// 1早退2迟到3出差
export function writeState(state){
  switch (state) {
    case 1:
      return this.$t('attendance.leaveEarly')
    case 2:
      return this.$t('attendance.beLate')
    case 3:
      return this.$t('attendance.businessTrip')
  }
}

// 1早退2迟到3出差
export function lockState(state){
  switch (state) {
    case 1:
      return "上锁"
    case 2:
      return "解锁"
  }
}


export function questionTypeFormatter (value) {
  switch (value) {
    case 1:
      return this.$t('training.multiple_choice')+this.$t('training.title')
    case 2:
      return this.$t('training.single_choice')+this.$t('training.title')
    case 3:
      return this.$t('training.true_false')+this.$t('training.title')
  }
}
export const formatDate = (time,parse='yyyy-MM-dd hh:mm:ss') => {
  if (time !== null && time !== '') {
    var date = new Date(time)
    return formatTimeToStr(date, parse)
  }  else {
    return ''
  }
}

export function getDay(day){
  let today = new Date();
  let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  let tYear = today.getFullYear();
  let tMonth = today.getMonth();
  let tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear+"-"+tMonth+"-"+tDate;
}

function doHandleMonth(month){
  let m = month;
  if(month.toString().length == 1){
    m = "0" + month;
  }
  return m;
}

export function getUrlKey(name,url){
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
}

export function getMember(arr){
  let assigneeStr = ''
  if (arr === undefined){
    return ''
  }
  arr.forEach(v => {
    assigneeStr += v.user.remarks + v.integral + ','
  })
  return assigneeStr
}

export function getFollowName(arr){
  let assigneeStr = ''
  if (arr === undefined){
    return ''
  }
  arr.forEach(v => {
    assigneeStr += v.NAME + ','
  })
  return assigneeStr
}

export function ProjectState(state){
  switch (state) {
    case 1:
      return this.$t('underDevelopment')
    case 2:
      return this.$t('inDesign')
    case 3:
      return this.$t('inProgress')
    case 4:
      return this.$t('finish')
    case 5:
      return this.$t('shipped')
    case 6:
      return this.$t('graded')
  }
}

export function ReportState(state){
  switch (state) {
    case 1:
      return this.$t('unrated')
    case 2:
      return this.$t('graded')
    case 3:
      return this.$t('pass')
    case 4:
      return this.$t('refute')
    case 5:
      return this.$t('fail')
  }
}

export function ApprovalState(state){
  switch (state) {
    case 1:
      return this.$t('pass')
    case 2:
      return this.$t('refute')
    case 3:
      return this.$t('fail')
  }
}

export function transTimestamp(datetime, dateSeprator = '/', timeSeprator = ':') {
  if (datetime) {
    const date = new Date(datetime)
    const year = `${date.getUTCFullYear()}`
    let month = `${date.getUTCMonth() + 1}`
    let day = `${date.getUTCDate()}`
    let hour = `${date.getUTCHours()}`
    let minute = `${date.getUTCMinutes()}`
    let second = `${date.getUTCSeconds()}`

    if (month.length === 1) {
      month = `0${month}`
    }
    if (day.length === 1) {
      day = `0${day}`
    }
    if (day.length === 1) {
      day = `0${day}`
    }
    if (hour.length === 1) {
      hour = `0${hour}`
    }
    if (minute.length === 1) {
      minute = `0${minute}`
    }
    if (second.length === 1) {
      second = `0${second}`
    }
    return `${year}${dateSeprator}${month}${dateSeprator}${day} ${hour}${timeSeprator}${minute}${timeSeprator}${second}`
  }
}

// 状态 1跟进中 2跟进完成 3验证完成 4验证不通过
export function InspectionState(state){
  switch (state) {
    case 1:
      return this.$t('inProgress')
    case 2:
      return this.$t('followUpCompleted')
    case 3:
      return this.$t('verifiedAsQualified')
    case 4:
      return this.$t('verificationIsNotQualified')
  }
}


// 状态 0（创建中）1（开始签到）2（结算）
export function TrainingState(state){
  switch (state) {
    case 1:
      return this.$t('inThePlan')
    case 2:
      return this.$t('started')
    case 3:
      return this.$t('settled')
    case 4:
      return this.$t('graded')
  }
}

export function QuestionType(state){
  switch (state) {
    case 1:
      return this.$t('training.multiple_choice')+this.$t('training.title')
    case 2:
      return this.$t('training.single_choice')+this.$t('training.title')
    case 3:
      return this.$t('training.true_false')+this.$t('training.title')
  }
}

export function formatSeconds (theTime) {
  let theTime1 = 0
  let theTime2 = 0
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60)
      theTime1 = parseInt(theTime1 % 60)
    }
  }
  let result = '' + parseInt(theTime) + '秒'
  if (theTime1 > 0) {
    result = '' + parseInt(theTime1) + '分' + result
  }
  if (theTime2 > 0) {
    result = '' + parseInt(theTime2) + '小时' + result
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/utils.js